export default function MissionSection() {
  return (
    <section className="py-24 px-6 bg-[#F8F6F3]">
      <div className="max-w-[1280px] mx-auto">
        {/* Label */}
        <div className="flex justify-center mb-10">
          <span className="inline-block px-4 py-1.5 rounded-full bg-[#1A4D3C]/10 text-[#1A4D3C] text-xs font-semibold uppercase tracking-widest">
            Our Purpose
          </span>
        </div>

        <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-bold text-[#2B2D2F] text-center mb-6">
          Building Bridges to Prosperity
        </h2>
        <p className="text-[#6B6B6B] text-center text-lg max-w-2xl mx-auto mb-16 font-['Inter'] font-light leading-relaxed">
          Harambee &mdash; meaning &ldquo;pulling together&rdquo; in Swahili &mdash; is more than a name. It is our commitment to collective advancement through disciplined education, strategic advisory, and cross-border collaboration.
        </p>

        {/* Mission / Vision Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-white rounded-lg p-10 border-l-4 border-[#1A4D3C]">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A4D3C]/10 mb-6">
              <i className="ri-compass-3-line text-[#1A4D3C] text-xl" />
            </div>
            <h3 className="font-['Cormorant_Garamond'] text-2xl font-bold text-[#2B2D2F] mb-4">Our Mission</h3>
            <p className="text-[#6B6B6B] text-base leading-relaxed font-['Inter']">
              To empower the African Diaspora and emerging investors with the financial education, advisory infrastructure, and cross-border networks needed to build lasting, intergenerational wealth. We deliver structured learning, investor-readiness support, and strategic guidance rooted in discipline and long-term thinking.
            </p>
          </div>

          <div className="bg-white rounded-lg p-10 border-l-4 border-[#C9A961]">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#C9A961]/15 mb-6">
              <i className="ri-eye-line text-[#C9A961] text-xl" />
            </div>
            <h3 className="font-['Cormorant_Garamond'] text-2xl font-bold text-[#2B2D2F] mb-4">Our Vision</h3>
            <p className="text-[#6B6B6B] text-base leading-relaxed font-['Inter']">
              To become the premier cross-border platform connecting the African Diaspora to transformative investment opportunities, world-class financial education, and a global network of strategic partners &mdash; anchored in Nairobi and reaching across continents.
            </p>
          </div>
        </div>

        {/* Values Row */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6">
          {[
            { icon: "ri-shield-check-line", label: "Integrity", desc: "Transparent, ethical, and accountable in all we do" },
            { icon: "ri-global-line", label: "Global Reach", desc: "Connecting diaspora communities across continents" },
            { icon: "ri-book-open-line", label: "Education First", desc: "Knowledge is the foundation of lasting wealth" },
            { icon: "ri-team-line", label: "Community", desc: "Collective advancement through shared purpose" },
          ].map((val) => (
            <div key={val.label} className="text-center p-6">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A4D3C]/10 mx-auto mb-4">
                <i className={`${val.icon} text-[#1A4D3C] text-xl`} />
              </div>
              <h4 className="font-['Cormorant_Garamond'] text-lg font-bold text-[#2B2D2F] mb-2">{val.label}</h4>
              <p className="text-[#6B6B6B] text-sm leading-relaxed font-['Inter']">{val.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
